import { AlertTriangle } from 'lucide-react';

const ConfirmWeekDialog = ({
  onConfirm,
  onCancel,
  title = "Are you sure?",
  message = "Do you want to proceed?",
  confirmLabel = "Yes, Confirm"
}) => (
  <div className="fixed inset-0 bg-black/60 flex items-center justify-center p-4 z-50 animate-fade-in-up">
    <div className="bg-white rounded-2xl shadow-2xl p-8 w-full max-w-[90vw] sm:max-w-md">

      <div className="text-center">
        <AlertTriangle className="mx-auto h-12 w-12 text-yellow-500" />
        <h3 className="mt-2 text-xl font-bold text-gray-800">{title}</h3>
        <p className="mt-2 text-sm text-gray-600">{message}</p>
      </div>

      <div className="mt-6 flex flex-col sm:flex-row justify-center gap-3">
        {
            title === "Unable to Delete Week(s)"
            ?
        <button
          onClick={onCancel}
          className="px-4 py-2 text-gray-700 font-semibold rounded-lg border border-gray-300 hover:bg-gray-100 transition"
        >
          Close
        </button>
            :
            <>
        <button
          onClick={onCancel}
          className="px-4 py-2 text-gray-700 font-semibold rounded-lg border border-gray-300 hover:bg-gray-100 transition"
        >
          Cancel
        </button>
        <button
          onClick={onConfirm}
          className={`px-4 py-2 ${confirmLabel?.includes("Delete") ? "bg-red-500 hover:bg-red-500/90" : "bg-[#166273] hover:bg-[#166273]/90"} text-white font-semibold rounded-lg shadow-md  transition`}
        >
          {confirmLabel}
        </button>
            </>
        }
      </div>

    </div>
  </div>
);

export default ConfirmWeekDialog;
